import React, { useState, useContext, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import MainLoader from "../../../utils/MainLoader/MainLoader";
import useAuth from "../../../hooks/useAuth";
import AuthContext from "../../../contexts/AuthContext";
import { AiFillEdit } from "react-icons/ai";
import { MdRemoveRedEye } from "react-icons/md";
import { MdAdminPanelSettings } from "react-icons/md";
import { CheckCircleTwoTone } from '@ant-design/icons';
import mapicon from "../../../assets/mapicon.svg"
import { Table, Space, Input, Checkbox, Button, Divider, Tag, Modal, List, Card, Typography, Flex, Select, Tooltip } from "antd";
import axios from "axios";
//import LoadingScreen from "../LoadingScreen";
const { TextArea } = Input;


const MyTask = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [feedback, setFeedback] = useState('');
    const [searchText, setSearchText] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [taskDetails, setTaskDetails] = useState(null);
    const [selectedTaskType, setSelectedTaskType] = useState(undefined);
    const [sortCriterion, setSortCriterion] = useState(undefined);
    const navigate = useNavigate();
    const location = useLocation();
    const { role } = useContext(AuthContext);
    const { logout } = useAuth();
    const { Paragraph } = Typography;
    const { Option } = Select;
    const [dialogVisible, setDialogVisible] = useState(false);
    const [refreshData, setRefreshData] = useState(false);
    const handleRefreshData = () => {
        setRefreshData(prevState => !prevState);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        navigate(location.pathname);
    };
    useEffect(() => {
        const fetchTasks = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}task/my_task`);
                setTasks(response.data.tasks);
                setIsLoading(false);
            } catch (error) {
                console.error(error);
                setIsLoading(false);
            }
        };

        fetchTasks();
    }, [refreshData]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const taskID = queryParams.get('taskID');

        if (taskID) {
            const task = tasks.find((task) => task.taskid === taskID);
            if (task) {
                setTaskDetails(task);
                setIsModalOpen(true);
            }
        }
    }, [location.search, tasks]);

    const handleViewDetails = (task) => {
        setTaskDetails(task);
        setIsModalOpen(true);
        const taskURL = `${location.pathname}?taskID=${task.taskid}`;
        navigate(taskURL);
    };

    const { Search } = Input;
    const [checkboxState, setCheckboxState] = useState({
        allTasks: true,
        pending: true,
        inProgress: true,
        completed: true,
        overdue: true,
        closed: true,
    });
    const [indeterminate, setIndeterminate] = useState(false);
    const handleCheckboxChange = (checkbox) => {
        if (checkbox === 'allTasks') {
            const newState = !checkboxState.allTasks;
            setCheckboxState({
                allTasks: newState,
                pending: newState,
                inProgress: newState,
                completed: newState,
                overdue: newState,
                closed: newState,
            });
            setIndeterminate(false);
        } else {
            setCheckboxState((prevState) => ({
                ...prevState,
                [checkbox]: !prevState[checkbox],
            }));
            const newState = {
                ...checkboxState,
                [checkbox]: !checkboxState[checkbox],
            };
            const { allTasks, ...rest } = newState;
            const allChecked = Object.values(rest).every((value) => value);
            const anyChecked = Object.values(rest).some((value) => value);

            setIndeterminate(!allChecked && anyChecked);
            setCheckboxState((prevState) => ({
                ...prevState,
                allTasks: allChecked,
            }));
        }
    };
    const [filteredTasks, setFilteredTasks] = useState([]);
    useEffect(() => {
        const filterTasks = () => {
            let filtered = [...tasks];

            // Filter by search text
            if (searchText) {
                filtered = filtered.filter(task =>
                    task.taskTitle.toLowerCase().includes(searchText.toLowerCase())
                );
            }

            // Filter by status
            if (!checkboxState.allTasks) {
                const selectedStatuses = Object.entries(checkboxState)
                    .filter(([key, value]) => value && key !== 'allTasks')
                    .map(([key]) => {
                        switch (key) {
                            case 'pending': return 'Pending';
                            case 'inProgress': return 'In Progress';
                            case 'completed': return 'Completed';
                            case 'overdue': return 'Overdue';
                            case 'closed': return 'Closed';
                            default: return '';
                        }
                    });
                filtered = filtered.filter(task => selectedStatuses.includes(task.status));
            }

            // Filter by task type
            if (selectedTaskType) {
                filtered = filtered.filter(task => task.taskType.toLowerCase() === selectedTaskType);
            }

            // Sort the filtered tasks
            filtered.sort((a, b) => {
                switch (sortCriterion) {
                    case 'dueDate':
                        return new Date(b.dueDate) - new Date(a.dueDate);
                    case 'createdDate':
                        return new Date(b.created_at) - new Date(a.created_at);
                    case 'assignedTo':
                        return a.assignedTo.localeCompare(b.assignedTo);
                    default:
                        return 0;
                }
            });

            setFilteredTasks(filtered);
        };

        filterTasks();
    }, [tasks, checkboxState, selectedTaskType, sortCriterion, searchText]);
    const handleTaskTypeChange = (value) => {
        setSelectedTaskType(value);
    };
    const resetFilters = () => {
        setSelectedTaskType(undefined);
        setSortCriterion(undefined);
    };
    const handleSearch = (value) => {
        setSearchText(value);
    };

    const CustomTableHeader = ({ checkboxState, handleCheckboxChange }) => (
        <>
            <div style={{ width: '100%' }}>
                <Search
                    placeholder="Search for a task"
                    allowClear
                    enterButton={<Button type="primary" ghost>Search</Button>}
                    size="large"
                    onSearch={handleSearch}
                    style={{ width: '100%' }}
                />
            </div>
            <Divider style={{ margin: '5px 0px' }} />
            <Space>
                <Select
                    value={sortCriterion}
                    style={{ width: 200, borderColor: '#1890ff' }}
                    onChange={(value) => setSortCriterion(value)}
                    placeholder="Sort by"
                >
                    <Option value="dueDate">Due Date</Option>
                    <Option value="createdDate">Created Date</Option>
                    <Option value="assignedTo">Assigned To</Option>
                </Select>

                <Select
                    value={selectedTaskType}
                    placeholder="Filter by task type"
                    style={{ width: 250, borderColor: '#1890ff' }}
                    onChange={handleTaskTypeChange}
                >
                    <Option value="maintenance">Maintenance</Option>
                    <Option value="survey">Survey</Option>
                </Select>
                <Button type="primary" ghost onClick={resetFilters}>Clear filter</Button>
                <Checkbox
                    indeterminate={indeterminate}
                    checked={checkboxState.allTasks}
                    onChange={() => handleCheckboxChange('allTasks')}
                >
                    All Task
                </Checkbox>
                <Checkbox
                    checked={checkboxState.pending}
                    onChange={() => handleCheckboxChange('pending')}
                >
                    Pending
                </Checkbox>
                <Checkbox
                    checked={checkboxState.inProgress}
                    onChange={() => handleCheckboxChange('inProgress')}
                >
                    In Progress
                </Checkbox>
                <Checkbox
                    checked={checkboxState.completed}
                    onChange={() => handleCheckboxChange('completed')}
                >
                    Completed
                </Checkbox>
                <Checkbox
                    checked={checkboxState.overdue}
                    onChange={() => handleCheckboxChange('overdue')}
                >
                    Overdue
                </Checkbox>
                <Checkbox
                    checked={checkboxState.closed}
                    onChange={() => handleCheckboxChange('closed')}
                >
                    Closed
                </Checkbox>
            </Space>
        </>
    );

    const columns = [
        {
            title: 'Task Title',
            dataIndex: 'taskTitle',
            key: 'taskTitle',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Task Type',
            dataIndex: 'taskType',
            key: 'taskType',
        },
        {
            title: 'Assigned To',
            dataIndex: 'assignedTo',
            key: 'assignedTo',
        },
        {
            title: 'Created On',
            dataIndex: 'created_at',
            key: 'createdOn',
        },
        {
            title: 'Due Date',
            dataIndex: 'dueDate',
            key: 'dueDate',
            render: (dueDate) => {
                const date = new Date(dueDate);
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                });
            },
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            render: (status) => {
                switch (status) {
                    case 'Closed':
                        return <Tag color="#ECECEC" style={{ color: '#425466' }}>Closed</Tag>;
                    case 'Pending':
                        return <Tag color="#FFFBD2" style={{ color: '#B35A04' }}>Pending</Tag>;
                    case 'In Progress':
                        return <Tag color="#EBF3FF" style={{ color: '#1967D2' }}>In Progress</Tag>;
                    case 'Completed':
                        return <Tag color="#DEFFE7" style={{ color: '#34A853' }}>Completed</Tag>;
                    case 'Overdue':
                        return <Tag color="#FFE3E3" style={{ color: '#DA2727' }}>Overdue</Tag>;
                    default:
                        return null;
                }
            },

        },
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
                <Space size="middle">
                    {(record.status === 'Completed' || record.status === 'Closed') ? (
                        <MdRemoveRedEye onClick={() => handleViewDetails(record)} style={{ cursor: 'pointer' }} />
                    ) : (
                        <AiFillEdit onClick={() => handleViewDetails(record)} style={{ cursor: 'pointer' }} />
                    )}
                </Space>

            ),
        },
    ];

    const statusBodyTemplate = (taskDetails) => {
        const getStatusTag = (status) => {
            switch (status) {
                case 'Closed':
                    return <Tag color="#ECECEC" style={{ color: '#425466' }}>Closed</Tag>;
                case 'Pending':
                    return <Tag color="#FFFBD2" style={{ color: '#B35A04' }}>Pending</Tag>;
                case 'In Progress':
                    return <Tag color="#EBF3FF" style={{ color: '#1967D2' }}>In Progress</Tag>;
                case 'Completed':
                    return <Tag color="#DEFFE7" style={{ color: '#34A853' }}>Completed</Tag>;
                case 'Overdue':
                    return <Tag color="#FFE3E3" style={{ color: '#DA2727' }}>Overdue</Tag>;
                default:
                    return null;
            }
        };

        return taskDetails.status ? getStatusTag(taskDetails.status) : null;
    };

    const renderContent = () => {
        if (taskDetails) {
            return (
                <Card
                    title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span>
                                    Assigned Task Details
                                </span>
                                <span style={{ fontSize: 14, fontWeight: 400 }}>
                                    Type: {taskDetails.taskType} Task
                                </span>
                            </div>

                            <div className="flex items-center" style={{ position: 'relative', width: 250, height: 45 }}>
                                <MdAdminPanelSettings style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', zIndex: 10 }} />
                                <Input
                                    disabled={true}
                                    value={`Assigned to you by ${taskDetails.assignedBy}`}
                                    style={{ paddingLeft: 35, width: '100%', height: '100%', borderRadius: 20, fontWeight: 600 }}
                                />
                            </div>
                        </div>
                    }
                    bordered={false}
                    style={{ width: '100%' }}
                >
                    <Paragraph style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#EFFBFF', padding: '10px', margin: '0 -24px', textAlign: 'center' }}>
                        <img src={mapicon} alt="map" />{taskDetails.roadNames}
                    </Paragraph>
                    <Flex gap="small">
                        <Flex gap="small" vertical>
                            <div
                                id="scrollableDiv"
                                style={{
                                    height: 190,
                                    width: 320,
                                    backgroundColor: '#FFF',
                                    overflow: 'hidden',
                                    marginTop: '16px',
                                    padding: '16px',
                                    border: '1px solid #FFF',
                                    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <List size="small"
                                    header={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ fontSize: 16, fontWeight: 600 }}>Task status</span>
                                        <span>{statusBodyTemplate(taskDetails)}</span>
                                    </div>
                                    }
                                >
                                    <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                        <span style={{ fontSize: 16, fontWeight: 600 }}> Created on </span>
                                        <span>{taskDetails.created_at}</span>
                                    </div>
                                    {taskDetails.accepted_at && (
                                        <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: 16, fontWeight: 600 }}> Accepted on </span>
                                            <span>{taskDetails.accepted_at}</span>
                                        </div>
                                    )}
                                    {taskDetails.completed_at && (
                                        <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: 16, fontWeight: 600 }}> Completed on </span>
                                            <span>{taskDetails.completed_at}</span>
                                        </div>
                                    )}
                                    {taskDetails.closed_at && (
                                        <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: 16, fontWeight: 600 }}> Closed on </span>
                                            <span>{taskDetails.closed_at}</span>
                                        </div>
                                    )}
                                </List>
                            </div>
                            <div
                                id="scrollableDiv"
                                style={{
                                    height: 115,
                                    width: 320,
                                    backgroundColor: '#FFF',
                                    overflow: 'hidden',
                                    padding: '16px',
                                    border: '1px solid #FFF',
                                    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <List size="small"
                                    header={<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <span style={{ fontSize: 16, fontWeight: 600 }}>Having issue performing this task? Notify the admin.</span>
                                        <span>Contact admin</span>
                                    </div>
                                    }
                                >
                                </List>
                            </div>
                        </Flex>
                        <div
                            id="taskdiv"
                            style={{
                                height: 313,
                                flexGrow: 1,
                                overflow: 'hidden',
                                margin: '16px 0px',
                                padding: '0px 16px',
                                border: '1px solid #FFF',
                                boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                                overflowY: 'auto',
                            }}
                        >
                            <Flex gap="small" vertical>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: 16, fontWeight: 600 }}>Task Title</span>
                                    <span >{taskDetails.taskTitle}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 2 }}>
                                    <span style={{ fontSize: 16, fontWeight: 600 }}>Task Description</span>
                                    <span>{taskDetails.taskDescription}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 16 }}>
                                    <span style={{ marginRight: '16px', fontSize: 16, fontWeight: 600 }}>Due Date</span>
                                    <span style={{ fontSize: 16, fontWeight: 400 }}>{taskDetails.dueDate}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 2 }}>
                                    <span style={{ marginRight: '32px', fontSize: 16, fontWeight: 600 }}>Task ID</span>
                                    <span style={{ fontSize: 16, fontWeight: 400 }}>{taskDetails.taskid}</span>
                                </div>
                                {taskDetails.status === 'In Progress' && (
                                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 2, marginBottom: 4 }}>
                                        <Tooltip title="Your feedback will be submitted once you complete the task!">
                                            <TextArea
                                                placeholder="Add a feedback for this task (optional)"
                                                autoSize={{ minRows: 2, maxRows: 4 }}
                                                style={{ width: '100%', height: '100%', fontWeight: 600 }}
                                                value={feedback}
                                                onChange={(e) => setFeedback(e.target.value)}
                                            />
                                        </Tooltip>
                                    </div>
                                )}
                                {taskDetails.feedback && (
                                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 2, marginBottom: 4 }}>
                                        <span style={{ fontSize: 16, fontWeight: 600 }}>Feedback from the assigned user</span>
                                        <TextArea
                                            disabled={true}
                                            placeholder="Feedback from the assigned user"
                                            autoSize={{ minRows: 3, maxRows: 4 }}
                                            style={{ width: '100%', height: '100%', fontWeight: 600, backgroundColor: '#EDEDED' }}
                                            value={taskDetails.feedback}
                                        />
                                    </div>
                                )}
                            </Flex>
                        </div>
                    </Flex>
                </Card >
            );
        }
        return null;
    }
    const footerContent = () => {
        const handleAccept = async () => {
            try {
                await axios.post(
                    `${process.env.REACT_APP_BASE_URL}task/accept_task`,
                    { taskId: taskDetails.taskid },
                    { headers: { 'Content-Type': 'application/json' } }
                );
                handleRefreshData();
                setIsModalOpen(false);
            } catch (error) {
                console.error(error);
            }
        };
        const handleComplete = async () => {
            try {
                await axios.post(
                    `${process.env.REACT_APP_BASE_URL}task/complete_task`,
                    { taskId: taskDetails.taskid, feedback: feedback },
                    { headers: { 'Content-Type': 'application/json' } }
                );
                handleRefreshData();
                setIsModalOpen(false);
            } catch (error) {
                console.error(error);
            }
        };
        if (taskDetails) {
            if (taskDetails.status === 'Pending') {
                return [
                    <div key="button-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button key="exit" danger ghost onClick={handleCancel}>Exit</Button>,
                        <Button key="assign" type="primary" icon={<CheckCircleTwoTone />} style={{ background: '#1967D2' }} onClick={handleAccept}>Start Task</Button>
                    </div>
                ];
            } else if (taskDetails.status === 'In Progress') {
                return [
                    <div key="button-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button key="exit" danger ghost onClick={handleCancel}>Exit</Button>,
                        <Button key="assign" type="primary" icon={<CheckCircleTwoTone />} style={{ background: '#1967D2' }} onClick={handleComplete}>Complete Task</Button>
                    </div>
                ];
            } else {
                return [<Button key="close" danger ghost onClick={handleCancel}>Close this window</Button>];
            }
        } else {
            return null;
        }
    };
    return (
        <>
            <div className="header px-8 flex w-full justify-between items-center p-2 bg-white">
                <div>
                    <h1 className="text-[1.5rem] font-semibold text-[#0A2540]">
                        My Task
                    </h1>
                    <p className="text-[#5F6368]">
                        View and manage your assigned tasks
                    </p>
                </div>
            </div>
            <div className="table-container p-5 text-lg bg-white">
                {isLoading ? <MainLoader /> :
                    <Table
                        columns={columns}
                        dataSource={filteredTasks}
                        bordered
                        title={() => <CustomTableHeader setSearchText={setSearchText} checkboxState={checkboxState} handleCheckboxChange={handleCheckboxChange} />}
                        scroll={{
                            y: 240,
                        }}
                    />
                }
            </div>
            <Modal
                centered
                closable={false}
                open={isModalOpen}
                onCancel={handleCancel}
                width="70vw"
                footer={footerContent()}
            >
                {renderContent()}
            </Modal>
        </>
    )
}

export default MyTask